import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What skills are important in VLSI?",
    description:
      "Key VLSI skills include digital electronics, CMOS concepts, Verilog/SystemVerilog, RTL design, timing analysis, physical design, and verification. Knowledge of semiconductor devices and debugging skills are also essential for VLSI roles.",
  },
  {
    title: "What tools are commonly used in VLSI?",
    description:
      "VLSI engineers use tools like Cadence, Synopsys, Mentor Graphics, Tanner EDA, and ModelSim. These tools assist in simulation, synthesis, layout, timing analysis, and chip verification throughout the design flow.",
  },
  {
    title: "What job roles are available in VLSI?",
    description:
      "Common VLSI roles include RTL Designer, Physical Design Engineer, Verification Engineer, DFT Engineer, Layout Engineer, and Validation Engineer. These positions exist in semiconductor, electronics, and chip-design companies worldwide.",
  },
  {
    title: "What projects will I work on in VLSI?",
    description:
      "You may work on digital logic design, RTL coding, processor modules, memory design, verification testbenches, and basic layout design. These projects help build hands-on experience with real VLSI workflows.",
  },
  {
    title: "Do VLSI engineers need programming?",
    description:
      "Yes. VLSI engineers use Verilog, SystemVerilog, and scripting languages like Python, TCL, and Shell. Programming knowledge helps automate tasks, write testbenches, and improve design efficiency.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
